import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { Layout } from 'components/Layout';
import { getPageStaticProps } from 'lib/dato-request';
import ParentsHero from '@/components/Parents/ParentsHero';
import VideoFlex from '@/components/Parents/VideoFlex';
import VideoFlex2 from '@/components/Parents/VideoFlex2';
import VideoFlex3 from '@/components/Parents/VideoFlex3';
import ExploreMath from '@/components/ExploreMath/ExploreMath';
import ThreeStepChild from '@/components/Parents/ThreeStepChild';
import FounderSection from '@/components/Parents/FounderSection';
import MailingList from '@/components/MailingList/MailingList';
import ParentsCTA from '@/components/Parents/ParentsCTA';
import { Trustbar2 } from '@/components/Trustbar2';
import ImageBarSection from '@/components/Trustbar2/ImageBarSection';
import TestimonialGrid from '@/components/TestimonialCarousel/TestimonialGrid';
import { BillboardArticle } from "@/components/AboutUs/Billboard";
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';



const BillboardPage = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    return (
        <Layout>
            <NextSeo title={seo?.title} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>

            <BillboardArticle image={components[10].featuredImage}/>

            <TestimonialGrid {...components[9]} className='bg-[#E0DCFF]' />

            {/*
            <VideoFlex3
                id='parents-video-3'
                heading={components[3].heading}
                subhead={components[3].subhead}
                featuredImage={components[3].featuredImage}
                featuredVideo={components[3].featuredVideo}
                videoLink={components[3].videoLink}
                buttonText='Start Free Trial Now'
                buttonLink={MUZOLOGY_SIGNUP_URL}
                background='linear-gradient(0deg, #E3E0FF 10%, #E0DDFF 60%)'
                // background='linear-gradient(180deg, #E0DCFF 39.64%, #FAFAFE 77.63%)'
            />*/}

            <FounderSection
                id='parents-founder'
                heading={components[6].heading}
                smallHeading={components[6].smallHeading}
                subhead={components[6].subhead}
                videoLink={components[6].videoLink}
                background='linear-gradient(0deg, #F9F8FF 0%, #E3E0FF 100%)'
            />

            <div style={{ background: 'linear-gradient(180deg, #F9F8FF 0%, #E6E3FF 59.9%)' }}>
                {/*<Trustbar3 className='' bgColor='none' logos={components[7].gallery} />*/}
                <ImageBarSection images={components[7].gallery} />
                {/*
                <div className='pb-[0px] -bg-red-100 default-max-w mx-auto'>
                    <Trustbar2 className='-bg-green-100' logos={components[7].gallery} />
                </div>
                */}

                <MailingList background='none' id='parents-mailing-list'/>

                <ParentsCTA
                    id='parents-cta'
                    headline='Try Muzology FREE with your child!'
                    text='Get started now with a 7-day free trial'
                    buttonText='Get Started Now'
                    buttonClassName='dark-button'
                    buttonLink={MUZOLOGY_SIGNUP_URL}
                />

                <Trustbar2
                    bgColor='none'
                    logos={components[8].gallery}
                    wide={true}
                    className='center-on-medium pb-10'
                    mediumImageMaxWidth='25%'
                    phoneImageMaxWidth='30%'
                />
                {/*
                <div className='w-full pb-[0px] pt-4 sm:mb-16 default-px'>
                    <div className='w-full default-max-w mx-auto'>
                        <Trustbar2 bgColor='none' logos={components[8].gallery} className='pb-10' />
                    </div>
                </div>
                */}
            </div>
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Billboard');
}

export default BillboardPage;
